<div class="svc-drawer-content" #drawerContent>
	<section class="flex-auto">
		<ng-content select="[svcDrawerContent]"></ng-content>
	</section>
</div>
<div *ngIf="isOver && isOpened" class="svc-drawer-overlay" (click)="toggle()"></div>
<div class="border shadow-xl svc-drawer-side" #drawerSide>
	<ng-content select="[svcDrawerSide]"></ng-content>
</div>